import {
  cartActions,
  defineElement,
  getCartItemProperties,
  getCartObject,
  getCartSectionsToRender,
  getSameCorporateGifts,
  hasKeys,
} from 'utils';

import { lineItemPropStrings } from 'lib/constants';
import RequestQueue from '~/utils/request-queue';

const requestQueue = new RequestQueue();

export class CartRemoveBase extends HTMLElement {
  constructor() {
    super();

    this.productType = this.getAttribute('data-product-type');
    this.isPhysicalProduct = this.productType === 'physical';

    this.addEventListener('click', (event) => {
      this.handleRemove(event);
    });
  }
}

export class CartRemoveButton extends CartRemoveBase {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.showTextLoading = this.hasAttribute('show-text-loading');
  }

  handleRemove(event) {
    event.preventDefault();

    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    const cartObject = getCartObject(cartItems);
    const cartItem = this.closest('.cart-item');
    const { properties, key } = getCartItemProperties(cartItem);

    cartItems.enableLoading();

    if (this.button && this.showTextLoading) {
      this.button.style.position = 'relative';
      this.button.querySelector('.button__text').style.opacity = 0;

      const loadingText = document.createElement('span');
      loadingText.classList.add('loading-text');
      loadingText.innerHTML = 'Removing...';

      this.button.appendChild(loadingText);
    }

    const change = {};
    const updates = {
      [key]: 0,
    };

    // If the product is a corporate gift and there are two corporate gifts in the cart
    if (properties[lineItemPropStrings.corporateGift]) {
      const corporateGifts = getSameCorporateGifts(cartObject.items, properties[lineItemPropStrings.corporateGroupKey]);

      if (corporateGifts.length === 2) {
        corporateGifts.forEach((product) => {
          updates[product.key] = 0;
        });
      }
    }

    const updateAction = async () =>
      cartActions.update(
        JSON.stringify({
          updates: updates,
          sections: getCartSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        })
      );

    const changeAction = async () =>
      cartActions.change(
        JSON.stringify({
          ...change,
          sections: getCartSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        })
      );

    const requestQueueCallback = async (response) => {
      const state = await response.text();
      cartItems.renderCartItems(state);
      cartItems.disableLoading();

      document.dispatchEvent(new CustomEvent('cart-item-removed', { detail: { cartItem } }));
    };

    if (hasKeys(updates)) requestQueue.enqueue(updateAction, requestQueueCallback);
    if (hasKeys(change)) requestQueue.enqueue(changeAction, requestQueueCallback);
  }
}

defineElement('cart-remove-button', CartRemoveButton);

export class CartRemoveButtonBulk extends CartRemoveBase {
  constructor() {
    super();
  }

  handleRemove(event) {
    event.preventDefault();
    const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
    const cartObject = getCartObject(cartItems);
    const cartItemGroup = this.closest('.cart-items-group');
    let cartItemGroupItems = null;

    if (cartItemGroup) {
      cartItemGroupItems = cartItemGroup.querySelectorAll('.cart-item--only-properties');
    } else {
      const cartItem = this.closest('.cart-item');
      const currentItemGroupKey = getCartItemProperties(cartItem).properties[lineItemPropStrings.corporateGroupKey];

      cartItemGroupItems = cartObject.items.filter((item) => {
        if (item.properties[lineItemPropStrings.corporateGroupKey] === currentItemGroupKey) {
          item['dataset'] = {
            key: item.key,
          };

          return item;
        }
      });
    }

    const updates = {};

    cartItemGroupItems.forEach((cartItem) => {
      const key = cartItem.dataset.key;

      updates[key] = 0;
    });

    // this.removeCartItems(JSON.stringify(body));
    cartItems.enableLoading();

    const updateAction = async () =>
      cartActions.update(
        JSON.stringify({
          updates: updates,
          sections: getCartSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        })
      );

    const requestQueueCallback = async (response) => {
      const state = await response.text();
      cartItems.renderCartItems(state);
      cartItems.disableLoading();
    };

    if (hasKeys(updates)) requestQueue.enqueue(updateAction, requestQueueCallback);
  }
}

defineElement('cart-remove-button-bulk', CartRemoveButtonBulk);
